export const quickSetupContent = {
  general: {
    walkthrough: {
      imageUrl: "https://lh3.googleusercontent.com/d/16pGwdALILvQFOoSn_50mEm9QMxnbr6tc",
      downloadImageUrl: "https://drive.google.com/file/d/16pGwdALILvQFOoSn_50mEm9QMxnbr6tc/view?usp=drive_link",
      videoUrl: "https://scribehow.com/embed/General_Walkthrough__oQt-AKVvSJKtkX6w8L4Bhw?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1CP_aWEhuvlVZdiqCvOvJbYggKqUp4pQt/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/General_Walkthrough__oQt-AKVvSJKtkX6w8L4Bhw?skipIntro=true&removeLogo=true",
    },
  },
  stripe: {
    setup: {
      videoUrl: "https://scribehow.com/embed/Setup_Stripe_Settings__L3s0p_dKS6ilnZ38fy_hxw?skipIntro=true&removeLogo=true", // Placeholder video URL
      pdfUrl: "https://drive.google.com/file/d/1isZ0IAR8Ku3fCIhE3tfUjfdlLFwRVVl6/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Setup_Stripe_Settings__L3s0p_dKS6ilnZ38fy_hxw?skipIntro=true&removeLogo=true",
    },
  },
  businessSettings: {
    businessDetails: {
      videoUrl: "https://scribehow.com/embed/Business_Details__Inv6t5XhTSaIyh6qyyBA9Q?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1Iu3sAZ03dv14XcP4HNv8zZRYy8sSaMnZ/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Business_Details__Inv6t5XhTSaIyh6qyyBA9Q?skipIntro=true&removeLogo=true",
    },
    websiteDetails: {
      videoUrl: "https://scribehow.com/embed/Website_Details__2jlYmac3QlmwiP-IljSPsw?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1HlACHncqqKycaf56iV4uFycMy79Ixi_X/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Website_Details__2jlYmac3QlmwiP-IljSPsw?skipIntro=true&removeLogo=true",
    },
    emailNotifications: {
      videoUrl: "https://scribehow.com/embed/Email_Notifications__2VSOZ_7iS5unB6yehogJCA?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/13EFIzx6SqrkdA3U6jYhfP6GevZiLQF2W/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Email_Notifications__2VSOZ_7iS5unB6yehogJCA?skipIntro=true&removeLogo=true",
    },
    accessControls: {
      videoUrl: "https://scribehow.com/embed/Configure_Access_Controls__ckQ67DtdTCaQdZ-KwBAPxQ?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1G9_t8rIJ9xSmR41HATymfuVTv60qysRR/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Configure_Access_Controls__ckQ67DtdTCaQdZ-KwBAPxQ?skipIntro=true&removeLogo=true",
    },
    displayOptions: {
      videoUrl: "https://scribehow.com/embed/Display_Options__5RrkePJfRIaVXK82ZQbGoQ?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1_9eHKjhGcIO7RAXsMMx4DVugs0r6gJ9U/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Display_Options__5RrkePJfRIaVXK82ZQbGoQ?skipIntro=true&removeLogo=true",
    },
  },
  clientCompanyOnboarding: {
    registerClient: {
      videoUrl: "https://scribehow.com/embed/Register_a_Client__LO5msrhBTSabaJrFuQRMAg?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/19kY9eKuhjgm4UDchxsU_-4yy05tgI2EY/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Register_a_Client__LO5msrhBTSabaJrFuQRMAg?skipIntro=true&removeLogo=true",
    },
    uploadClients: {
      videoUrl: "https://scribehow.com/embed/Upload_Clients_in_Bulk__wd7YqkuEQuG_hsEHE8N2FA?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1TAFHRQhZ6xsD25fl6VGdT-uMFILHeL7Z/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Upload_Clients_in_Bulk__wd7YqkuEQuG_hsEHE8N2FA?skipIntro=true&removeLogo=true",
    },
    companyProfiles: {
      videoUrl: "https://scribehow.com/embed/Setup_Company_Profiles__hIER5fx0TBWBbPamgyRRNA?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/13x5ylBya4JMps1T8EC0YtON_0mgiRJkU/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Setup_Company_Profiles__hIER5fx0TBWBbPamgyRRNA?skipIntro=true&removeLogo=true",
    },
  },
  fleetSetup: {
    vehicles: {
      videoUrl: "https://scribehow.com/embed/Add_Your_Own_Vehicles__O1TkEQ8DSJKyQMUAMqPLFA?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1cXypX1V6w1x3B_05oUTcsr_yCSR9soiA/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Add_Your_Own_Vehicles__O1TkEQ8DSJKyQMUAMqPLFA?skipIntro=true&removeLogo=true",
    },
    partneredDrivers: {
      videoUrl: "https://scribehow.com/embed/Invite_Partnered_Drivers__SENki5U1TpuElcvzlnkRvA?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1KMv4LMkbVxwOam5SfYI2xwX69frt4E_T/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Invite_Partnered_Drivers__SENki5U1TpuElcvzlnkRvA?skipIntro=true&removeLogo=true",
    },
  },
  tripSettings: {
    tripCost: {
      videoUrl: "https://scribehow.com/embed/Trip_Cost__B1GWbQ86RfadPqUfmUCNlw?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/14KSKTrB90qUmJABg-d20g9JMqdyFLS1L/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Trip_Cost__B1GWbQ86RfadPqUfmUCNlw?skipIntro=true&removeLogo=true",
    },
    timeAndDay: {
      videoUrl: "https://scribehow.com/embed/Time_and_Day_Multiplier__WIeE85XQS7unZOTnnTGNxw?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1gJ8GTzOZjjpxfdtSgEw50o16joP1vEbQ/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Time_and_Day_Multiplier__WIeE85XQS7unZOTnnTGNxw?skipIntro=true&removeLogo=true",
    },
    hourlyHire: {
      videoUrl: "https://scribehow.com/embed/Hourly__Daily_Hire__-dmMcmHyQeKcDIFiVPAXwQ?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1lMDRmBG98UxE_iL-6G18lDQZYiW6EBr2/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Hourly__Daily_Hire__-dmMcmHyQeKcDIFiVPAXwQ?skipIntro=true&removeLogo=true",
    },
    vehicleOptions: {
      videoUrl: "https://scribehow.com/embed/Transfer_Types_and_Vehicle__PL9CMMi7TvKsBZq-UDBtXw?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1dgfD_p1gvTdaxZwtb0US-6SL1A5t9jMs/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Transfer_Types_and_Vehicle__PL9CMMi7TvKsBZq-UDBtXw?skipIntro=true&removeLogo=true",
    },
    unscheduledStops: {
      videoUrl: "https://scribehow.com/embed/Unscheduled_Stops__kxtuN-kERDq-IkQYba4bVQ?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1E6jXxAcSGSl7RZKcZSAZ-ADhPsKWvtDW/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Unscheduled_Stops__kxtuN-kERDq-IkQYba4bVQ?skipIntro=true&removeLogo=true",
    },
    cancellationFees: {
      videoUrl: "https://scribehow.com/embed/Cancellation_Fees__kXkXdEFsQu6VdJt1FNMomg?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1AkiH0gdbeFmbExpRrark_LKVE32LhnAz/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Cancellation_Fees__kXkXdEFsQu6VdJt1FNMomg?skipIntro=true&removeLogo=true",
    },
    billingSettings: {
      videoUrl: "https://scribehow.com/embed/Billing_Settings__14xKKaP0Q0mV7J7fN0LS4Q?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1aCRiDdurTeA-39gDlRnbyRR9E9LB8P1e/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Billing_Settings__14xKKaP0Q0mV7J7fN0LS4Q?skipIntro=true&removeLogo=true",
    },
    waitingTimes: {
      videoUrl: "https://scribehow.com/embed/Waiting_Times__0BFZQFZhS6yT7GfQ9hZHug?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1Cy4DHcjqXfQYl5P1hK2dRgPh8zQ92sdZ/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Waiting_Times__0BFZQFZhS6yT7GfQ9hZHug?skipIntro=true&removeLogo=true",
    },
    dispatchSettings: {
      videoUrl: "https://scribehow.com/embed/Dispatch_Settings__KiAl76qbQuym_MFD0golCw?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1gq-PVMFj9JGCWaBEhdgbO9yTuG1OWR1w/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Dispatch_Settings__KiAl76qbQuym_MFD0golCw?skipIntro=true&removeLogo=true",
    },
  },
  addons: {
    setup: {
      videoUrl: "https://scribehow.com/embed/Add_Ons__u506ZU6GT7y8mUO7gCoFzQ?skipIntro=true&removeLogo=true",
      pdfUrl: "https://drive.google.com/file/d/1kekDLV7j-LOOWst5nYGOHWZuFkBGFj__/view?usp=drive_link",
      documentationUrl: "https://scribehow.com/embed/Add_Ons__u506ZU6GT7y8mUO7gCoFzQ?skipIntro=true&removeLogo=true",
    },
  },
  soloOnboarding: {
    // Download only — the guide card is a single Download PDF button per Figma 11573:108963.
    // No Scribe walkthrough here by decision, unlike the per-section entries above.
    guide: {
      pdfUrl: "https://drive.google.com/file/d/1pvYJM27z1ivDJ1H_cShiWIgmmqZWUxK3/view?usp=sharing",
    },
  },
} as const;

export const quickSetupExplanations = {
  general: {
    walkthrough: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description:
          "This gives you a complete overview of how to get set up on the platform. By following the walkthrough, you'll see every step in sequence so nothing gets overlooked.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description:
          "You risk missing critical steps in setup, which can delay your ability to accept bookings, manage payments, or configure your account correctly.",
      },
    ],
  },
  stripe: {
    setup: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description:
          "Stripe connects your business to secure, automated payments. Setting this up means you can accept bookings, process transactions seamlessly, and ensure your drivers and business are paid on time.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description:
          "Without Stripe connected, you won't be able to process payments. This means customers can't pay you through the platform, blocking trips from being booked and leaving your business at a standstill.",
      },
    ],
  },
  businessSettings: {
    businessDetails: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description:
          "Defines your company profile in the system. This ensures invoices, reports, and communications reflect your business identity.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Your clients may see incomplete or inaccurate information, which undermines professionalism and trust.",
      },
    ],
    websiteDetails: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Lets clients access your instant quote link and ensures your brand is presented consistently online.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Clients may have no easy way to reach or book with you, limiting visibility and revenue opportunities.",
      },
    ],
    emailNotifications: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Ensures your business communicates correctly with clients and drivers for trip confirmations, changes, and updates.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You risk missed notifications, confused clients, and breakdowns in service delivery.",
      },
    ],
    accessControls: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Allows you to assign the right permissions to staff, ensuring data security and role-based access.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Staff may either lack needed access (causing delays) or have too much access (causing security risks).",
      },
    ],
    displayOptions: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Customises how your services, pricing, and policies appear to clients, aligning with your brand.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Your clients may see default or confusing displays, which could cause friction or mistrust.",
      },
    ],
  },
  tripSettings: {
    tripCost: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Sets up your base pricing rules so clients are charged correctly and consistently.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You risk undercharging or overcharging.",
      },
    ],
    timeAndDay: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Allows you to adjust pricing for peak times, weekends, or holidays to reflect demand and costs.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You may lose revenue during high-demand periods or fail to cover operational costs.",
      },
    ],
    hourlyHire: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Enables flexible, time-based bookings for clients who need vehicles by the hour.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You'll miss out on key revenue streams and fail to serve clients with hourly trip needs.",
      },
    ],
    vehicleOptions: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Defines the types of transfers and vehicles you offer so clients know their options when booking.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Your clients may see limited or no options, which reduces bookings and creates confusion.",
      },
    ],
    unscheduledStops: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Lets you define how to handle unplanned stops, including pricing and policies.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Unclear policies may lead to disputes with clients, unexpected costs, or driver frustration.",
      },
    ],
    cancellationFees: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Protects your business by ensuring costs are covered when clients cancel last-minute.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You'll lose revenue and drivers may be left unpaid for reserved time.",
      },
    ],
    billingSettings: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Ensures invoices are accurate, professional, and aligned with your business practices.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Invoices may be incorrect or incomplete, causing payment delays and client dissatisfaction.",
      },
    ],
    waitingTimes: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Defines how long drivers wait and how charges apply, ensuring fairness and efficiency.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Drivers may waste time unpaid, or clients may be frustrated by unclear charges.",
      },
    ],
    dispatchSettings: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Controls how bookings are assigned to drivers, ensuring efficient operations.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Trips may not be allocated properly, leading to missed bookings or delays.",
      },
    ],
  },
  fleetSetup: {
    vehicles: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Registers vehicles so they can be assigned to bookings.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You won't be able to allocate trips, preventing operations from running.",
      },
    ],
    partneredDrivers: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Expands your fleet capacity by including partnered drivers.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You'll be limited to only your own vehicles and drivers, restricting scale and flexibility.",
      },
    ],
  },
  clientCompanyOnboarding: {
    registerClient: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Allows individual clients to book and manage trips directly with your business.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "Clients can't access your services, limiting growth and revenue.",
      },
    ],
    uploadClients: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Saves time by onboarding multiple clients at once.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You'll have to add clients one by one, slowing down onboarding.",
      },
    ],
    companyProfiles: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Allows corporate clients to book, manage, and track trips for their staff.",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You won't be able to serve corporate accounts, missing out on high-value partnerships.",
      },
    ],
  },
  addons: {
    setup: [
      {
        type: "success" as const,
        title: "Why is this important?",
        description: "Enables additional features that enhance the platform (e.g., integrations, advanced tools).",
      },
      {
        type: "error" as const,
        title: "What happens if I don't do this?",
        description: "You'll miss out on features that could improve efficiency, client experience, or revenue.",
      },
    ],
  },
};
